exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-videoElementWrapper-1YZmjfvF {\n  width: 100%;\n}\n\n.styles-videoElement-ji663A-P {\n  position: relative;\n  overflow: hidden;\n}\n\n.styles-videoElement-ji663A-P iframe, .styles-videoElement-ji663A-P object, .styles-videoElement-ji663A-P embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.styles-videoWrapper-2ro0bSmh {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  padding-top: 56.25%;\n  position: relative;\n}\n\n.styles-videoWrapper-2ro0bSmh .styles-inner-3ClctETD {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n", ""]);

// exports
exports.locals = {
	"videoElementWrapper": "styles-videoElementWrapper-1YZmjfvF",
	"videoElement": "styles-videoElement-ji663A-P",
	"videoWrapper": "styles-videoWrapper-2ro0bSmh",
	"inner": "styles-inner-3ClctETD"
};